import classNames from 'classnames';
import React from 'react';

interface LineAndBlockProps {
  numberOfLines?: number;
  numberOfBlocks?: number;
  lineClassName?: string;
  blockClassName?: string;
}

const LineAndBlock = ({
  numberOfLines,
  numberOfBlocks,
  lineClassName,
  blockClassName,
}: LineAndBlockProps) => {
  return (
    <div className="w-full">
      <div className="animate-pulse flex space-x-4">
        <div className="flex-1 space-y-3">
          {numberOfLines &&
            Array.from({ length: numberOfLines }, (_, i) => (
              <div
                key={i}
                data-testid={`line-${i}`}
                className={classNames(
                  'h-8 bg-slate-300 rounded',
                  lineClassName,
                )}
              ></div>
            ))}
          {numberOfBlocks &&
            Array.from({ length: numberOfBlocks }, (_, i) => (
              <div
                key={i}
                data-testid={`block-${i}`}
                className={classNames(
                  'h-[70px] bg-slate-300 rounded',
                  blockClassName,
                )}
              ></div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default LineAndBlock;
